import clsx from 'clsx'
import { AnimatePresence, motion } from 'motion/react'
import NextLink from 'next/link'
import { useEffect, useState } from 'react'

const products = [
  'place',
  'address',
  'region',
  'customer',
  'sales',
  'resource',
  'asset'
]

const subheading =
  'Mapstack is the AI-powered mapping platform for business that helps your team create interactive maps in seconds.'

const debug = false

const Link = motion(NextLink as any)

export function Hero() {
  return (
    <div
      className={clsx(
        'min-h-fit py-[80px]',
        'laptop:pt-[80px] laptop:pb-[40px]'
      )}
    >
      <div
        className={clsx(
          'flex overflow-visible px-[60px] h-[31vw] gap-[2rem] justify-between items-center',
          'laptop:gap-[2rem] laptop:items-center laptop:h-auto laptop:px-[56px]',
          'max-[768px]:gap-[0rem] max-[768px]:flex-col max-[768px]:h-auto max-[768px]:flex-start max-[768px]:items-center max-[768px]:px-[16px]'
        )}
      >
        <div
          className={clsx(
            'flex justify-start items-start gap-[40px] flex-col',
            'max-[768px]:gap-[24px] max-[768px]:items-center max-[768px]:w-full max-[768px]:mb-[40px]'
          )}
        >
          <div className='flex flex-col max-[768px]:items-center max-[768px]:justify-center gap-y-[24px] items-start justify-start'>
            <Heading />
            <p className='max-[768px]:text-center text-[clamp(18px,1.2vw,22px)] leading-tight font-[400] text-black w-[440px] text-left'>
              {subheading}
            </p>
          </div>
          <div className={clsx('flex flex-col items-center')}>
            <Link
              href='/sign-in'
              whileHover={{
                scale: 1.1,
                transition: { duration: 0.3, ease: 'easeInOut' }
              }}
              className='bg-brand-02 rounded-lg p-[18px] text-[18px] leading-[12.8px] font-bold tracking-tight text-white lg:px-[32px] lg:py-[24px] lg:text-2xl lg:leading-[17px]'
            >
              Make your free map
            </Link>
            <div className='mt-[14px] text-center font-sans leading-[110%] font-[500] text-neutral-700'>
              It’s super easy & <br />
              no credit card required!
            </div>
          </div>
        </div>

        <div
          className={clsx(
            'border-[1px] border-gray-300 border-solid rounded-2xl overflow-hidden w-[45.15vw] h-auto',
            'max-[768px]:w-full max-[768px]:items-center max-[768px]:h-[59vw]'
          )}
        >
          <video
            muted
            autoPlay
            loop
            playsInline
            preload='metadata'
            controls={false}
          >
            <source
              src={`${process.env.NEXT_PUBLIC_MS_ASSETS_URL}/public/videos/optimized-map-preview.mp4`}
              type='video/mp4'
            />
          </video>
        </div>
      </div>
    </div>
  )
}

function Heading() {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (debug) return
    const interval = setInterval(() => {
      setIndex((previous) => {
        const current = (previous + 1) % products.length
        return current
      })
    }, 3000)
    return () => clearInterval(interval)
  }, [index])

  return (
    <AnimatePresence mode='popLayout'>
      <motion.h1
        key={index}
        className='max-[768px]:text-center max-[768px]:text-[10vw] leading-[110%] font-[700] tracking-tight text-left text-[3.8vw]'
        initial={{ opacity: 0.4 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0.4 }}
      >
        <div className='max-[768px]:hidden block whitespace-nowrap'>
          Magically create
          <br />
          stunning <span className='text-brand-05'>{products[index]}</span> maps
          <br />
          with AI.
        </div>

        <div className='max-[768px]:block hidden'>
          Magically
          <br />
          create
          <br />
          stunning <span className='text-brand-05'>{products[index]}</span>
          <br />
          maps
          <br />
          with AI.
        </div>
      </motion.h1>
    </AnimatePresence>
  )
}
